import React from 'react';

import {Loading} from 'presentation/components/Loading/Loading';
import {useTheme} from '@mui/material';
import {StyledCard, StyledCardActionArea, StyledIcon, StyledTypography} from './styles';
import {ShortcutCardProps} from './types';

export function ShortcutCard({
	loading,
	handleClick,
	dataTagId,
	dataTestId,
	icon,
	hasEmphasis,
	title,
	breakTitle,
	customFontSize,
	layoutVariant = 'default',
	...cardProps
}: ShortcutCardProps) {
	const {palette} = useTheme();

	return (
		<StyledCardActionArea
			disabled={loading}
			onClick={handleClick}
			data-tag-id={dataTagId}
			data-test-id={dataTestId}
			$layoutVariant={layoutVariant}>
			<StyledCard
				variant="outlined"
				$hasEmphasis={hasEmphasis}
				$layoutVariant={layoutVariant}
				{...cardProps}>
				{loading ? (
					<Loading
						size={16}
						fullWidth={false}
						sx={{color: hasEmphasis ? palette.common.white : palette.primary.main}}
					/>
				) : (
					<StyledIcon
						name={icon}
						size={layoutVariant === 'portal' ? 28 : 24}
						$hasEmphasis={hasEmphasis}
						$layoutVariant={layoutVariant}
					/>
				)}
				<StyledTypography
					$hasEmphasis={hasEmphasis}
					$breakTitle={breakTitle}
					$customFontSize={customFontSize}
					$layoutVariant={layoutVariant}>
					{title}
				</StyledTypography>
			</StyledCard>
		</StyledCardActionArea>
	);
}
